var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ErrorHandler } from "@angular/core";
import * as Raven from 'raven-js';
export function errorHandlerFactory(settings, currentUser) {
    return new RavenErrorHandler(settings, currentUser);
}
var RavenErrorHandler = /** @class */ (function (_super) {
    __extends(RavenErrorHandler, _super);
    /**
     * RavenErrorHandler Constructor.
     */
    function RavenErrorHandler(settings, currentUser) {
        var _this = _super.call(this) || this;
        _this.settings = settings;
        _this.currentUser = currentUser;
        /**
         * Whether sentry error logger is already installed.
         */
        _this.installed = false;
        /**
         * Http error codes that should not be reported.
         */
        _this.dontReport = [
            401, 402, 403, 422
        ];
        return _this;
    }
    /**
     * Handle specified error.
     */
    RavenErrorHandler.prototype.handleError = function (err) {
        //if there's no error, or it's a validation error return, bail
        if (!err || (err.type === 'http' && this.dontReport.indexOf(err.status) > -1))
            return;
        _super.prototype.handleError.call(this, err);
        //sentry did not install properly
        if (!this.installSentry())
            return;
        Raven.captureException(err.originalError || err);
    };
    /**
     * Install sentry error logger.
     */
    RavenErrorHandler.prototype.installSentry = function () {
        //already installed
        if (this.installed)
            return true;
        //no sentry public key is set
        if (!this.settings.has('logging.sentry_public'))
            return false;
        //install
        Raven.config(this.settings.get('logging.sentry_public'), {
            release: this.settings.get('version'),
            extra: { user: this.currentUser.getModel() },
            ignoreErrors: [
                'requestAnimationFrame is not defined',
                "Object [object DOMWindow] has no method 'cancelAnimationFrame'",
                'Uncaught (in promise): [object Object]',
                '[object Object]',
                '{"isTrusted"\n true}',
                "'block' member of ScrollIntoViewOptions 'center' is not a valid value for enumeration ScrollLogicalPosition.",
            ]
        }).install();
        if (this.currentUser.isLoggedIn()) {
            Raven.setUserContext({
                id: this.currentUser.get('id'),
                username: this.currentUser.get('display_name'),
                email: this.currentUser.get('email')
            });
        }
        return this.installed = true;
    };
    return RavenErrorHandler;
}(ErrorHandler));
export { RavenErrorHandler };



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/raven-error-handler.ts.pre-build-optimizer.js